import React from 'react'
// import Footer from './Footer'
import {Link} from 'react-router-dom'
import { FaArrowRight } from "react-icons/fa";
// import { Link } from 'react-router-dom'

const Services = () => {
  return (
    <div style={{backgroundColor:"#000435"}}>
  <div className='heading'>
    <br></br> <br></br>
   <h3 className='concept' > FROM CONCEPT TO REALITY </h3>
   <br></br>
   <h1  className='ytt' > Your Trusted Technology Partner, Delivering Customized IT Services To Accelerate Business Success</h1>
  </div>
   
 <div className='maincontainer-seven'>
 <div className='leftone-sixth' >
 <img src='/images/webs-image.jpg' className="websimage " alt="..." />

  </div>

  <div className='rightone-fifth' >
   <h1 className='wd' style={{color:"white"}} > Website Development</h1>
   <br/>
   <h3  className="cwa">Custom web & app development with strategic
    sights to generate greater brand engagement </h3>
    <Link to="/WebsiteDevelopment">
    
  
    <button className='click' onMouseEnter={(e) => {e.currentTarget.style.color = "black"; e.currentTarget.style.transform = "scale(1)";}}
      onMouseLeave={(e) => {e.currentTarget.style.color = "white"; e.currentTarget.style.transform = "scale(0.9)";}} >Explore Website Development Services</button>   </Link>
    <ul className="space-y-2" style={{color:"white",marginTop:"7%"}}>
      <h5 className='cwdsec'> 
       <FaArrowRight className="text-blue-500">
       </FaArrowRight>  E-Commerce Development<br></br> 
        </h5> 
       
    <h5 className='cwd' > 
       <FaArrowRight className="text-blue-500">
       </FaArrowRight>  Custom Website Design & Development<br></br> 
        </h5  > 
       
        <h5 className='cwd' > 
       <FaArrowRight className="text-blue-500">
       </FaArrowRight>   Responsive & Mobile-Friendly Websites<br></br> 
        </h5> 
       
        
        <h5 className="cwdforth"> 
       <FaArrowRight >
       </FaArrowRight>  Web Applications (React, Next.js, Node.js)  <br></br> 
        </h5> 
    </ul>
  </div>
  
</div>

<div className='maincontainer-seven'>
  <div className='rightone-fifth'>
   <h1 className='dmt' style={{color:"white"}} > Digital Marketing</h1>
   <br/>
   <h3 className='cwa' >Digital marketing is the practice of promoting products or services using online channels such as search engines </h3>
   <Link to ="/Dm">
    <button className=' click' onMouseEnter={(e) => {e.currentTarget.style.color = "black"; e.currentTarget.style.transform = "scale(1)";}}
      onMouseLeave={(e) => {e.currentTarget.style.color = "white"; e.currentTarget.style.transform = "scale(0.9)";}} >Explore Digital Marketing Services</button>    </Link>

    <ul className="space-y-2" style={{color:"white",marginTop:"5%"}}>

       <h5 className='cwd-third  '> 
       <FaArrowRight className="text-blue-500">
       </FaArrowRight> Email Marketing<br></br> 
        </h5>  

    <h5  className='cwd'> 
       <FaArrowRight className="text-blue-500">
       </FaArrowRight>   Search Engine Optimization (SEO) <br></br> 
        </h5  > 
       
        <h5  className="cwd-fifth">   
       <FaArrowRight className="text-blue-500">
       </FaArrowRight>   Social Media Marketing (SMM)<br></br> 
        </h5> 
       
       
       
        <h5 className='cwd-fifth' > 
       <FaArrowRight className="text-blue-500">
       </FaArrowRight> Pay-Per-Click Advertising (PPC)  <br></br> 
        </h5> 
    </ul>
  </div>
  <div className='leftone-sixth' >
 <img src='/images/Digital-marketing.png' className="digimage" alt="..." />

  </div>
</div> 
<div className='maincontainer-seven'>
 <div className='leftonesixth' >
 <img src='/images/Android-development.jpg' className="websimage" alt="..." />

  </div>

  <div className='rightone-fifth' >
   <h1 className='adc' style={{color:"white"}} > Android  Development</h1>
   <br/>
   <h3 className='cwa'> Android development is the process of creating applications for devices running the Android operating system.</h3>
   <Link to="/AppD">
   <button className=' click' onMouseEnter={(e) => {e.currentTarget.style.color = "black"; e.currentTarget.style.transform = "scale(1)";}}
      onMouseLeave={(e) => {e.currentTarget.style.color = "white"; e.currentTarget.style.transform = "scale(0.9)";}} >Explore Android Development Services</button>
   </Link>
   
    <ul className="space-y-2" style={{color:"white",marginTop:"5%"}}>
    <h5 className='cwd' > 
       <FaArrowRight className="text-blue-500">
       </FaArrowRight>  Java & Kotlint<br></br> 
        </h5  > 
       
        <h5 className='cwd'> 
       <FaArrowRight className="text-blue-500">
       </FaArrowRight> Android Studio<br></br> 
        </h5> 
       
        <h5  className='cwd'> 
       <FaArrowRight className="text-blue-500">
       </FaArrowRight> jetpack Compose<br></br> 
        </h5> 
       
        <h5 className='cwd'> 
       <FaArrowRight className="text-blue-500">
       </FaArrowRight> Retrofit & Volley  <br></br> 
        </h5> 
    </ul>
  </div>
  
</div> 
<div className='maincontainer-seven'>
 

  <div className='rightone-fifth'>
   <h1 className='gdc' style={{color:"white"}} > Graphic Design </h1>
   <br/>
   <h3  className=' cwa'>Graphic designing is the art of creating visual content to communicate messages effectively </h3>
   <Link to ="/GraphicDesign">
   
  
   <button className=' click'onMouseEnter={(e) => {e.currentTarget.style.color = "black"; e.currentTarget.style.transform = "scale(1)";}}
      onMouseLeave={(e) => {e.currentTarget.style.color = "white"; e.currentTarget.style.transform = "scale(0.9)";}} >Explore Graphic Design Services</button>
     </Link>
    <ul className="gd" style={{color:"white",marginTop:"7%"}}>
    <h5 className='gd' > 
       <FaArrowRight className="text-blue-500">
       </FaArrowRight> Canva <br></br> 
        </h5> 

        <h5 className='gd'> 
       <FaArrowRight className="text-blue-500">
       </FaArrowRight> Figma/XD<br></br> 
        </h5> 

        <h5 className='gd'> 
       <FaArrowRight className="text-blue-500">
       </FaArrowRight> Adobe Illustrator<br></br> 
        </h5> 
       
    
        <h5 className='gd'> 
       <FaArrowRight className="text-blue-500">
       </FaArrowRight>  Adobe Photoshop <br></br> 
        </h5> 
    </ul>
  </div>
  <div className='leftone-sixth'>
 <img src='/images/Graphic-home.jpg' className="graimage" alt="..." />

  </div>
</div> 


      {/* <Footer/> */}
    </div>
  )
}

export default Services;
